// extracted by css-extract-rspack-plugin
export default {"upcoming-trip-placeholder__media":"upcoming-trip-placeholder__media___kSoEO3Go","upcoming-trip-placeholder__label":"upcoming-trip-placeholder__label___afquTJWO"};